import React from 'react';

const IconLogo = () => (
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    width="261.021"
    height="298.536"
    viewBox="0 0 261.021 298.536">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(130.5105, 149.268)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="-122.0208 -70.7107 0 -145.2214 138.0208 -70.7107 138.0208 70.7107 0 150.8214 -122.0208 70.7107"
        />
      </g>
    </g>
    <text
      transform="translate(54.305 216.621)"
      fill="currentColor"
      font-size="200"
      font-family="SegoeUI-Semibold, Segoe UI"
      font-weight="600">
      <tspan x="0" y="0">
        A
      </tspan>
    </text>
  </svg>
);

export default IconLogo;
